import { getAnalyticsActor, posthog } from './posthog'

/**
 * Mở màn bộ tưới (M-137): đếm bao nhiêu bộ có thông số đất, bao nhiêu bộ số
 * liệu đã cũ, bao nhiêu bộ chưa đọc được. KHÔNG gửi số đo hay mã bộ tưới: chỉ
 * số đếm. Analytics lỗi hoặc tắt không được chặn màn hình.
 */
export function captureIrrigationSensorsViewed(input: {
    devices: number
    withSensors: number
    stale: number
    noReading: number
}) {
    try {
        const actor = getAnalyticsActor()
        if (!actor) return
        posthog.capture('irrigation_sensors_viewed', {
            schema_version: 1,
            event_id: crypto.randomUUID(),
            ...actor,
            devices: input.devices,
            with_sensors: input.withSensors,
            stale: input.stale,
            no_reading: input.noReading,
        })
    } catch {
        // Analytics không được chặn màn bộ tưới.
    }
}
